"use strict";
const _ = require("lodash");
const ComboBoxControlRenderer = require("./ComboBoxControlRenderer");
const SelectListControl = require("@gluenetworks/select_list").Single;
const MultipleSelectListControl = require("@gluenetworks/select_list").Multiple;

class IconComboBoxControlRenderer extends ComboBoxControlRenderer {
    constructor(model) {
        super(model);
    }

    _renderSelectList() {
        let listConfig = {};
        if (this._model.optionIcon) {
            listConfig.optionIcon = this._model.optionIcon;
        }
        if (this._model.selectedOptionIcon) {
            listConfig.selectedOptionIcon = this._model.selectedOptionIcon;
        }
        if (this._model.multiple === true) {
            this._rootElem.dataset.multiple = true;
            this._selectList = new MultipleSelectListControl(listConfig);
        } else {
            this._selectList = new SelectListControl(listConfig);
        }
    }

    _setValue(newVal) {
        super._setValue(newVal);

        if (newVal instanceof Array) {
            // Until we get comps, icons will not be displayed in the selection view of multi select
        } else {
            this._model.options.forEach((option) => {
                if (_.isEqual(option.value, newVal)) {
                    this._selectionDisplay.innerHTML = option.label;
                    this._setSelectionIcon(option.value);
                }
            });
        }
        this._selectList.value = newVal;
    }

    _setSelectionIcon(optionValue) {
        let optionIcon = this._selectList.getOptionIcon(optionValue);
        let iconEl = document.createElement("base-icon-gl");
        iconEl.dataset.icon = optionIcon;
        this._selectionDisplay.insertAdjacentElement("afterbegin", iconEl);
        this._selectionDisplay._glIconElem = iconEl;
    }
}

module.exports = IconComboBoxControlRenderer;
